// extracted by mini-css-extract-plugin
export default {"footer-link":"footer-link__hUIRk","icon":"icon__e3DE3","spinner":"spinner__SHfF5"};